import { AsyncPipe } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AppService } from 'src/app/app.service';
import { CurrencyWalletService } from 'src/app/layouts/currency-wallet/currency-wallet.service';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { MatConnectedDialog, MatConnectedDialogMobileAnimation } from '../../service/connected-dialog';
import { CSSwitchComponent } from '../cs-switch/cs-switch.component';
import {
  FiatSelectorDialogComponent,
  FiatSelectorDialogData,
  FiatSelectorDialogResult,
} from './fiat-selector-dialog/fiat-selector-dialog.component';

@UntilDestroy()
@Component({
  selector: 'app-fiat-display-switch',
  standalone: true,
  imports: [FormsModule, PipesModule, AsyncPipe, CSSwitchComponent],
  templateUrl: './fiat-display-switch.component.html',
  styleUrl: './fiat-display-switch.component.scss',
})
export class FiatDisplaySwitchComponent {
  constructor(
    private appService: AppService,
    private matConnectedDialog: MatConnectedDialog,
    protected currencyWalletService: CurrencyWalletService,
  ) {}

  private static _uid = 0;
  private readonly _idPrefix = 'app-fiat-display-switch';
  protected readonly id = this._idPrefix + FiatDisplaySwitchComponent._uid++;

  @Output() fiatSelectionBtnClick = new EventEmitter<void>();

  protected onFiatSelectionBtnClick(): void {
    this.fiatSelectionBtnClick.emit();

    // 為避免關閉彈窗時，父元件已 destroy 的問題，所以都交給 currencyWalletService 處理
    this.matConnectedDialog.open<FiatSelectorDialogComponent, FiatSelectorDialogData, FiatSelectorDialogResult>(
      FiatSelectorDialogComponent,
      {
        mobileAnimation: MatConnectedDialogMobileAnimation.SLIDE_UP,
        mobileFixedBottom: true,
      },
    );
  }
}
